import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Hitung Kalori yang Terbakar Saat Berjalan";
const DESCRIPTION = "Kalkulator akurat untuk memperkirakan kalori yang terbakar berdasarkan jumlah langkah, berat badan, tinggi badan, dan kecepatan berjalan";
const KEYWORDS = "kalkulator kalori, kalkulator langkah, pembakaran kalori, berjalan, kebugaran fisik";
const OG_URL = "https://do-calculate.com/calculator/id/steps-to-calories/";
function StepsToCaloriesCalculator() {
    const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [steps, setSteps] = useState("");
    const [speed, setSpeed] = useState("average");
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");
    const calculateCalories = () => {
        try {
            setError("");
            if (!weight || !height || !steps) {
                throw new Error("Harap masukkan semua nilai yang diperlukan");
            }
            const weightKg = parseFloat(weight);
            const heightM = parseFloat(height) / 100;
            const stepsCount = parseFloat(steps);
            if (weightKg <= 0 || heightM <= 0 || stepsCount <= 0) {
                throw new Error("Nilai harus lebih besar dari nol");
            }
            let met;
            let pace;
            switch (speed) {
                case "slow":
                    met = 2.8;
                    pace = 0.9;
                    break;
                case "average":
                    met = 3.5;
                    pace = 1.34;
                    break;
                case "fast":
                    met = 5.0;
                    pace = 1.79;
                    break;
                default:
                    met = 3.5;
                    pace = 1.34;
            }
            const stride = heightM * 0.414;
            const distance = stride * stepsCount;
            const time = distance / pace;
            const caloriesBurned = time * met * 3.5 * weightKg / (200 * 60);
            const caloriesPerStep = caloriesBurned / stepsCount;
            setResult({
                caloriesBurned: caloriesBurned.toFixed(2),
                caloriesPerStep: caloriesPerStep.toFixed(5),
                distance: (distance / 1000).toFixed(2)
            });
        } catch (error) {
            setError(error.message);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: "50px" }}>
                        <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>Kalkulator ini memperkirakan kalori yang terbakar saat berjalan berdasarkan jumlah langkah yang Anda ambil.</p>
                                <p>
                                    Berjalan adalah latihan paling sederhana karena tidak memerlukan peralatan khusus, Anda tidak perlu membayar keanggotaan gym yang mahal, dan Anda dapat melakukannya di mana saja.
                                </p>
                                <p>Untuk menghitung kalori yang terbakar, kami menggunakan rumus berikut:</p>
                                <ul>
                                    <li>Mempertimbangkan berat badan, tinggi badan, dan kecepatan berjalan Anda</li>
                                    <li>Menghitung MET (Metabolic Equivalent) berdasarkan kecepatan berjalan</li>
                                    <li>Menerapkan rumus ilmiah yang menghubungkan langkah dan kalori</li>
                                </ul>
                                <p>Kalkulator ini dikembangkan berdasarkan studi ilmiah di bidang metabolisme dan aktivitas fisik.</p>
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds/>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white">
                                    <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                                </div>
                                <div >
                                    <div>
                                        <hr />
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="weight">
                                                Berat Badan (kg)
                                            </label>
                                            <input
                                                id="weight"
                                                type="number"
                                                value={weight}
                                                onChange={(e) => setWeight(e.target.value)}
                                                placeholder="Masukkan berat badan Anda dalam kilogram"
                                                className="form-control"
                                                style={{ width: "75%" }}
                                                min="1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="height">
                                                Tinggi Badan (cm)
                                            </label>
                                            <input
                                                id="height"
                                                type="number"
                                                value={height}
                                                onChange={(e) => setHeight(e.target.value)}
                                                placeholder="Masukkan tinggi badan Anda dalam sentimeter"
                                                className="form-control"
                                                style={{ width: "75%" }}
                                                min="1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="steps">
                                                Jumlah Langkah
                                            </label>
                                            <input
                                                id="steps"
                                                type="number"
                                                value={steps}
                                                onChange={(e) => setSteps(e.target.value)}
                                                placeholder="Masukkan jumlah langkah"
                                                className="form-control"
                                                style={{ width: "75%" }}
                                                min="1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="speed">
                                                Kecepatan Berjalan
                                            </label>
                                            <select
                                                id="speed"
                                                value={speed}
                                                onChange={(e) => setSpeed(e.target.value)}
                                                className="form-control"
                                                style={{ width: "75%" }}
                                            >
                                                <option value="slow">Lambat (3.2 km/jam - 0.9 m/dtk)</option>
                                                <option value="average">Sedang (5 km/jam - 1.34 m/dtk)</option>
                                                <option value="fast">Cepat (6.5 km/jam - 1.79 m/dtk)</option>
                                            </select>
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: "20px", marginLeft: "10px" }}
                                            onClick={calculateCalories}
                                        >
                                            Hitung
                                        </button>
                                    </div>
                                    <br />
                                    { error !== "" && (
                                        <p className="p-3 mb-2 bg-warning text-black">
                                            Kesalahan: {error}
                                        </p>
                                    )}
                                    {result &&  (
                                        <div className="p-3 mb-2 bg-success text-white">
                                            <h4>Hasil:</h4>
                                            <p className="text-white">Jarak yang ditempuh: {result.distance} km</p>
                                            <p className="text-white">Kalori yang terbakar: {result.caloriesBurned} kalori</p>
                                            <p className="text-white">Kalori per langkah: {result.caloriesPerStep} kalori</p>
                                        </div>
                                    )}
                                    <hr />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: "auto" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Informasi tentang Kalkulator</div>
                            <div className="info-section-body">
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>Bagaimana Kalkulator Ini Bekerja?</h2>
                                    </u>
                                    <p>Kalkulator ini memperkirakan kalori yang terbakar berdasarkan beberapa faktor:</p>
                                    <ul>
                                        <li>Berat Badan: Semakin berat Anda, semakin banyak kalori yang terbakar</li>
                                        <li>Tinggi Badan: Tinggi badan mempengaruhi panjang langkah dan jumlah langkah</li>
                                        <li>Jumlah Langkah: Ukuran dasar aktivitas fisik</li>
                                        <li>Kecepatan Berjalan: Mempengaruhi intensitas aktivitas dan tingkat pembakaran</li>
                                    </ul>
                                    <hr />
                                    <div>
                                        <p>Kami menggunakan rumus ilmiah yang akurat berikut:</p>
                                        <ol>
                                            <li>Menghitung panjang langkah: Tinggi (meter) × 0.414</li>
                                            <li>Menghitung jarak tempuh: Panjang langkah × jumlah langkah</li>
                                            <li>Menghitung waktu berjalan: Jarak / kecepatan</li>
                                            <li>Menghitung kalori: Waktu × MET × 3.5 × berat badan / (200 × 60)</li>
                                        </ol>
                                        <p>Di mana:</p>
                                        <ul>
                                            <li>MET: Tergantung kecepatan berjalan (lambat: 2.8, sedang: 3.5, cepat: 5.0)</li>
                                            <li>Kecepatan: Lambat (0.9 m/dtk), Sedang (1.34 m/dtk), Cepat (1.79 m/dtk)</li>
                                        </ul>
                                        <hr />
                                    </div>
                                    <br />
                                    <div className="p-3 mb-2 bg-info">
                                        Contoh: Seseorang dengan berat 70 kg, tinggi 170 cm, berjalan 10.000 langkah dengan kecepatan sedang akan membakar sekitar 400 kalori.
                                    </div>
                                    <br />
                                </div>
                                <hr />
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>Tips untuk Meningkatkan Pembakaran Kalori</h2>
                                    </u>
                                    <ul>
                                        <li>Coba tingkatkan jumlah langkah harian Anda secara bertahap</li>
                                        <li>Pilih rute dengan tanjakan untuk meningkatkan usaha</li>
                                        <li>Tingkatkan kecepatan berjalan Anda secara bertahap</li>
                                        <li>Gunakan penghitung langkah untuk melacak kemajuan Anda</li>
                                    </ul>
                                    <p>
                                        Pakar kebugaran Denise Austin mengatakan: "Berjalan adalah salah satu cara tercepat dan termudah untuk membakar kalori, karena Anda dapat melakukannya kapan saja dan di mana saja, bahkan di dalam rumah Anda."
                                    </p>
                                    <p>
                                        Timothy Burnett, instruktur kinesiologi di Oregon State University Cascades mengatakan: "Perkiraan cepat jumlah kalori yang dibakar oleh orang rata-rata dengan berjalan adalah 100 kalori per mil, baik Anda berlari atau berjalan santai."
                                        Sederhananya, semakin cepat kecepatan, semakin sedikit waktu yang Anda perlukan untuk membakar jumlah kalori yang sama.
                                    </p>
                                    <hr />
                                </div>
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>
                                    </u>
                                    <p><strong>Apakah kalkulator ini akurat?</strong></p>
                                    <p>Hasil bersifat perkiraan dan mungkin sedikit berbeda per individu, tetapi memberikan gambaran perkiraan yang baik.</p>
                                    <p><strong>Mengapa tinggi badan mempengaruhi perhitungan?</strong></p>
                                    <p>Karena orang yang lebih tinggi memiliki langkah yang lebih panjang, sehingga menempuh jarak lebih jauh dengan jumlah langkah yang sama.</p>
                                    <p><strong>Bagaimana cara meningkatkan akurasi perhitungan?</strong></p>
                                    <p>Gunakan penghitung langkah yang andal, dan ukur berat serta tinggi badan Anda dengan akurat.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
}
export default StepsToCaloriesCalculator;